import WeekPicks from "@/routes/contents/WeekPicks.vue";
import ProductListItem from "@/components/ui/ProductListItem.vue";
import TrendRender from "@/routes/contents/TrendRender.vue";
import SwiperSliderProducts from "@/components/ui/SwiperSliderProducts.vue";
export const GlobalComponentPlugin = {
  install(app) {
    app.component('WeekPicks', WeekPicks)
    app.component('TrendRender', TrendRender);
    app.component('ProductListItem', ProductListItem);
    app.component('SwiperSliderProducts', SwiperSliderProducts);
  }
}
